import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip, Modal, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_helpers";
import { downloadImagebyFileId } from "../../../../../../../app/services/PublicCrudService";

const ImageColumnFormatter = ({ cellContent, row }) => {
  const [show, setShow] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const downloadImage = (imageFileDescriptionId) => {
    if (imageFileDescriptionId) {
      downloadImagebyFileId("api/FileManagement", imageFileDescriptionId)
        .then((response) => {
          const temp = `data:image/jpeg;base64,${response.data}`;
          console.log(temp)
          setImageSrc(temp);
          handleShow();
        })
        .catch((error) => {
          alert(error);
        });
    }else{
      alert("عکس جهت نمابش وجود ندارد")
    }
  };

  return (
    <>
      <OverlayTrigger overlay={<Tooltip id="objects-editCredit-tooltip">نمایش عکس</Tooltip>}>
        <a
          className="btn btn-icon btn-light btn-hover-info btn-sm"
          onClick={() => downloadImage(row.imageFileDescriptionId)}
        >
          <span className="svg-icon svg-icon-md svg-icon-success">
            <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Cloud-download.svg")} />
          </span>
        </a>
      </OverlayTrigger>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>تصویر</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {imageSrc ? <img src={imageSrc} alt="Downloaded" style={{ width: "100%" }} /> : "در حال بارگذاری..."}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ImageColumnFormatter;
